module.exports = __webpack_public_path__ + "static/media/mf.6ea2b1d1.svg";